import FbButton from 'components/FbUI/FbButton'
import { MobileModal } from 'components/UI/Modal/MobileModal'
import { ReactNode } from 'react'

type Props = {
  title: string
  onClose: () => void
  onSubmit: () => void
  children: ReactNode
}

export function MobileFiltersModal({
  title = 'Filter Locations',
  onClose,
  onSubmit,
  children,
}: Props) {
  return (
    <MobileModal
      header={
        <div className="p-2">
          <div className="text-xs uppercase tracking-wide text-gray-500 mb-1">
            {title}
          </div>
          <h1 className="text-2xl font-semibold text-gray-900">All Filters</h1>
        </div>
      }
      footer={
        <div>
          <div className="flex gap-4 p-2 justify-between">
            <div className="w-1/2">
              <FbButton
                className="w-full"
                type="button"
                size="mdlg"
                variant="secondary"
                onClick={onClose}
              >
                Cancel
              </FbButton>
            </div>
            <div className="w-1/2">
              <FbButton
                className="w-full"
                type="button"
                size="mdlg"
                variant="primary"
                onClick={onSubmit}
              >
                Save
              </FbButton>
            </div>
          </div>
        </div>
      }
    >
      {children}
    </MobileModal>
  )
}
